import type Owner from '@ember/owner';
import { service } from '@ember/service';
import Component from '@glimmer/component';

import type { Service } from 'webapp-types';

import CommonFullscreenLoaderComponent from 'webapp/components/common/fullscreen-loader';

type Args = object;

// exit from this step is handled case by case depending on onboarding flow,
// mostly by redirecting to another route (see onboardingService.markCompleted flows)

export default class OnboardingStepsFinalComponent extends Component<Args> {
	@service('onboarding') declare onboardingService: Service.Onboarding;

	constructor(owner: Owner, args: Args) {
		super(owner, args);

		if (this.onboardingService.isEligibleForMarketplaceSkillFlow) {
			void this.onboardingService.finishMarketplaceSkillOnboarding();
			return;
		}

		// Fallback exit for owner flows that can land here with no completion
		// path armed (e.g. FlowB with account-setup skipped).
		this.onboardingService.armFinalStepSafeGuard();
	}

	<template>
		<CommonFullscreenLoaderComponent>
			<p>Your account is being prepared...</p>
		</CommonFullscreenLoaderComponent>
	</template>
}
